<template>
  <div class="page-wrapper">
    <!-- ====================== PC 端（原代码完全不变） ====================== -->
    <div class="pc-version">
      <div
        class="menu-table-container"
        v-loading="loading"
        element-loading-text="拼命加载中..."
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.3)"
      >
        <!-- 顶部搜索栏 -->
        <div class="search-bar">
          <el-input
            v-model="searchParams.username"
            placeholder="请输入管理员名称"
            clearable
            style="width: 220px; margin-right: 10px"
          ></el-input>
          <el-button type="primary" icon="el-icon-search" @click="getMenuList">
            搜索
          </el-button>
          <el-button icon="el-icon-refresh" @click="resetSearch"> 重置 </el-button>
          <el-button
            type="success"
            icon="el-icon-plus"
            style="margin-left: 10px"
            @click="openAddDialog"
          >
            添加管理员
          </el-button>
        </div>

        <!-- 表格 -->
        <el-table
        height="900"
          :data="tableData"
          border
          stripe
          style="width: 100%; margin-top: 20px"
        >
          <el-table-column label="ID" prop="id" width="80" align="center" />
          <el-table-column label="用户名" prop="username" min-width="150" />
          <el-table-column label="角色" prop="role_name" min-width="150" />
          <el-table-column label="创建时间" prop="created_at" width="180" />
          <el-table-column label="更新时间" prop="updated_at" width="180" />
          <el-table-column label="操作" width="100" align="center">
            <template slot-scope="scope">
              <el-button
                type="text"
                icon="el-icon-edit"
                @click="handleEdit(scope.row)"
              >
                编辑
              </el-button>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页 -->
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="searchParams.page"
          :page-size="searchParams.page_size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pageInfo.total"
          style="margin-top: 20px; text-align: right"
        ></el-pagination>

        <!-- PC 添加弹窗 -->
        <el-dialog
          title="添加管理员"
          :visible.sync="addDialogVisible"
          width="500px"
          @close="resetAddForm"
          append-to-body
        >
          <el-form
            :model="addForm"
            :rules="addRules"
            ref="addForm"
            label-width="100px"
          >
            <el-form-item label="用户名" prop="name">
              <el-input v-model="addForm.name" placeholder="请输入用户名"></el-input>
            </el-form-item>
            <el-form-item label="密码" prop="password">
              <el-input v-model="addForm.password" placeholder="请输入密码" show-password></el-input>
            </el-form-item>
            <el-form-item label="确认密码" prop="re_password">
              <el-input v-model="addForm.re_password" placeholder="请再次输入密码" show-password></el-input>
            </el-form-item>
            <el-form-item label="角色" prop="role_id">
              <el-select v-model="addForm.role_id" placeholder="请选择角色">
                <el-option
                  v-for="item in role_data"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="addDialogVisible = false">取消</el-button>
            <el-button type="primary" @click="submitAddMenu">确认添加</el-button>
          </div>
        </el-dialog>

        <!-- PC 编辑弹窗 -->
        <el-dialog
          title="编辑管理员"
          :visible.sync="editDialogVisible"
          width="500px"
          @close="resetEditForm"
          append-to-body
        >
          <el-form
            :model="editForm"
            :rules="addRules"
            ref="editForm"
            label-width="100px"
          >
            <el-form-item label="用户名">
              <el-input v-model="editForm.username" placeholder="请输入用户名"></el-input>
            </el-form-item>
            <el-form-item label="角色" prop="role_id">
              <el-select v-model="editForm.role_id" placeholder="请选择角色">
                <el-option
                  v-for="item in role_data"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="editDialogVisible = false">取消</el-button>
            <el-button type="primary" @click="submitEditMenu">确认修改</el-button>
          </div>
        </el-dialog>
      </div>
    </div>

    <!-- ====================== 移动端（全新独立版） ====================== -->
    <div class="mobile-version">
      <div
        class="mobile-menu-container"
        v-loading="loading"
        element-loading-text="加载中..."
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0,0,0,0.4)"
      >
        <!-- 搜索栏 -->
        <div class="mobile-search-bar">
          <el-input
            v-model="searchParams.username"
            placeholder="搜索管理员"
            clearable
            prefix-icon="el-icon-search"
          />
          <div class="mobile-btn-group">
            <el-button type="primary" plain @click="getMenuList">搜索</el-button>
            <el-button plain @click="resetSearch">重置</el-button>
          </div>
          <el-button type="success" round block @click="openAddDialogMobile">
            <i class="el-icon-plus"></i> 添加管理员
          </el-button>
        </div>

        <!-- 卡片列表 -->
        <div class="mobile-card-list">
          <div class="card-item" v-for="item in tableData" :key="item.id">
            <div class="card-top">
              <span class="id-tag">ID：{{ item.id }}</span>
              <span class="role-tag">{{ item.role_name }}</span>
            </div>
            <div class="card-title">{{ item.username }}</div>
            <div class="card-time">
              <div>创建：{{ item.created_at }}</div>
              <div>更新：{{ item.updated_at }}</div>
            </div>
            <div class="card-operate">
              <el-button type="primary" icon="el-icon-edit" round @click="handleEditMobile(item)">
                编辑
              </el-button>
            </div>
          </div>
        </div>

        <!-- 分页 -->
        <div class="mobile-pagination">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="searchParams.page"
            :page-size="searchParams.page_size"
            layout="total, prev, pager, next, jumper"
            :total="pageInfo.total"
          />
        </div>

        <!-- ====================== 移动端添加弹窗（独立） ====================== -->
        <el-dialog
          title="添加管理员"
          :visible.sync="addDialogVisibleMobile"
          width="92%"
          top="10vh"
          custom-class="mobile-dialog"
          @close="resetAddForm"
          append-to-body
        >
          <el-form
            :model="addForm"
            :rules="addRulesMobile"
            ref="addFormMobile"
            label-width="80px"
          >
            <el-form-item label="用户名" prop="name">
              <el-input v-model="addForm.name" placeholder="请输入用户名" size="medium"></el-input>
            </el-form-item>
            <el-form-item label="密码" prop="password">
              <el-input
                v-model="addForm.password"
                placeholder="请输入密码"
                show-password
                size="medium"
              ></el-input>
            </el-form-item>
            <el-form-item label="确认密码" prop="re_password">
              <el-input
                v-model="addForm.re_password"
                placeholder="请再次输入密码"
                show-password
                size="medium"
              ></el-input>
            </el-form-item>
            <el-form-item label="角色" prop="role_id">
              <el-select
                v-model="addForm.role_id"
                placeholder="请选择角色"
                size="medium"
              >
                <el-option
                  v-for="item in role_data"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </el-form>
          <div slot="footer" class="mobile-dialog-footer">
            <el-button size="medium" @click="addDialogVisibleMobile = false">取消</el-button>
            <el-button type="primary" size="medium" @click="submitAddMenuMobile">确认添加</el-button>
          </div>
        </el-dialog>

        <!-- ====================== 移动端编辑弹窗（独立） ====================== -->
        <el-dialog
          title="编辑管理员"
          :visible.sync="editDialogVisibleMobile"
          width="92%"
          top="10vh"
          custom-class="mobile-dialog"
          @close="resetEditForm"
          append-to-body
        >
          <el-form
            :model="editForm"
            :rules="editRulesMobile"
            ref="editFormMobile"
            label-width="80px"
          >
            <el-form-item label="用户名">
              <el-input
                v-model="editForm.username"
                placeholder="请输入用户名"
                size="medium"
              ></el-input>
            </el-form-item>
            <el-form-item label="角色" prop="role_id">
              <el-select
                v-model="editForm.role_id"
                placeholder="请选择角色"
                size="medium"
              >
                <el-option
                  v-for="item in role_data"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </el-form>
          <div slot="footer" class="mobile-dialog-footer">
            <el-button size="medium" @click="editDialogVisibleMobile = false">取消</el-button>
            <el-button type="primary" size="medium" @click="submitEditMenuMobile">确认修改</el-button>
          </div>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import api from "../../api/api.js";
export default {
  name: "MenuTable",
  data() {
    return {
      loading: false,
      tableData: [],
      pageInfo: { total: 0 },
      searchParams: { page: 1, page_size: 10, username: "", role_name: "" },
      pageSizes: [10, 20, 50, 100, 200, 500, 800, 1000, 2000],
      pid_data: [],
      role_data: [],

      // ========== PC 弹窗 ==========
      addDialogVisible: false,
      editDialogVisible: false,

      // ========== 移动端 独立弹窗 ==========
      addDialogVisibleMobile: false,
      editDialogVisibleMobile: false,

      addForm: {
        name: "",
        password: "",
        re_password: "",
        role_id: 1,
      },
      editForm: {
        id: "",
        username: "",
        role_id: "",
      },

      // PC 校验
      addRules: {
        name: [{ required: true, message: "请输入用户名", trigger: "blur" }],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
        re_password: [
          { required: true, message: "请再次输入密码", trigger: "blur" },
          {
            validator: (rule, value, callback) => {
              if (value !== this.addForm.password) {
                callback(new Error("两次输入密码不一致"));
              } else {
                callback();
              }
            },
            trigger: "blur"
          }
        ],
        role_id: [{ required: true, message: "请选择角色", trigger: "change" }],
      },

      // 移动端添加校验
      addRulesMobile: {
        name: [{ required: true, message: "请输入用户名", trigger: "blur" }],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
        re_password: [
          { required: true, message: "请再次输入密码", trigger: "blur" },
          {
            validator: (rule, value, callback) => {
              if (value !== this.addForm.password) {
                callback(new Error("两次密码不一致"));
              } else callback();
            },
            trigger: "blur"
          }
        ],
        role_id: [{ required: true, message: "请选择角色", trigger: "change" }],
      },

      // 移动端编辑校验
      editRulesMobile: {
        role_id: [{ required: true, message: "请选择角色", trigger: "change" }],
      },
    };
  },
  created() {
    this.getMenuList();
  },
  methods: {
    // ==================== 列表 ====================
    getMenuList() {
      this.loading = true;
      api.admin
        .index({ params: this.searchParams })
        .then((res) => {
          if (res.data.code == 1000) {
            this.tableData = res.data.data.data;
            this.pageInfo.total = res.data.data.total;
            this.role_data = res.data.data.role_data;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },

    // ==================== PC 方法 ====================
    openAddDialog() {
      this.addDialogVisible = true;
    },
    submitAddMenu() {
      this.$refs.addForm.validate((valid) => {
        if (!valid) return;
        this.loading = true;
        api.admin
          .add({
            username: this.addForm.name,
            password: this.addForm.password,
            re_password: this.addForm.re_password,
            role_id: this.addForm.role_id,
          })
          .then((res) => {
            if (res.data.code == 1000) {
              this.resetSearch();
              this.addDialogVisible = false;
            }
          })
          .finally(() => {
            this.loading = false;
          });
      });
    },
    handleEdit(row) {
      this.editForm = { ...row };
      this.editDialogVisible = true;
    },
    submitEditMenu() {
      this.$refs.editForm.validate((valid) => {
        if (!valid) return;
        this.loading = true;
        api.admin
          .edit({
            admin_id: this.editForm.id,
            username: this.editForm.username,
            role_id: this.editForm.role_id,
          })
          .then((res) => {
            if (res.data.code == 1000) {
              this.getMenuList();
              this.editDialogVisible = false;
            }
          })
          .finally(() => {
            this.loading = false;
          });
      });
    },

    // ==================== 移动端 方法 ====================
    openAddDialogMobile() {
      this.addDialogVisibleMobile = true;
    },
    submitAddMenuMobile() {
      this.$refs.addFormMobile.validate((valid) => {
        if (!valid) return;
        this.loading = true;
        api.admin
          .add({
            username: this.addForm.name,
            password: this.addForm.password,
            re_password: this.addForm.re_password,
            role_id: this.addForm.role_id,
          })
          .then((res) => {
            if (res.data.code == 1000) {
              this.resetSearch();
              this.addDialogVisibleMobile = false;
            }
          })
          .finally(() => {
            this.loading = false;
          });
      });
    },

    handleEditMobile(row) {
      this.editForm = { ...row };
      this.editDialogVisibleMobile = true;
    },
    submitEditMenuMobile() {
      this.$refs.editFormMobile.validate((valid) => {
        if (!valid) return;
        this.loading = true;
        api.admin
          .edit({
            admin_id: this.editForm.id,
            username: this.editForm.username,
            role_id: this.editForm.role_id,
          })
          .then((res) => {
            if (res.data.code == 1000) {
              this.getMenuList();
              this.editDialogVisibleMobile = false;
            }
          })
          .finally(() => {
            this.loading = false;
          });
      });
    },

    // ==================== 公共 ====================
    resetAddForm() {
      this.addForm = { name: "", password: "", re_password: "", role_id: 1 };
      if (this.$refs.addForm) {
        this.$refs.addForm.clearValidate();
      }
      if (this.$refs.addFormMobile) {
        this.$refs.addFormMobile.clearValidate();
      }
    },
    resetEditForm() {
      this.editForm = { id: "", username: "", role_id: "" };
      if (this.$refs.editForm) {
        this.$refs.editForm.clearValidate();
      }
      if (this.$refs.editFormMobile) {
        this.$refs.editFormMobile.clearValidate();
      }
    },
    resetSearch() {
      this.searchParams.username = "";
      this.getMenuList();
    },
    handleSizeChange(val) {
      this.searchParams.page_size = val;
      this.getMenuList();
    },
    handleCurrentChange(val) {
      this.searchParams.page = val;
      this.getMenuList();
    },
  },
};
</script>

<style scoped>
/* ==================== PC 样式 ==================== */
.menu-table-container {
  padding: 20px;
}
.search-bar {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
}
.dialog-footer {
  text-align: right;
}

/* ==================== 移动端主体样式 ==================== */
.mobile-menu-container {
  padding: 12px;
  box-sizing: border-box;
}
.mobile-search-bar {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 12px;
}
.mobile-btn-group {
  display: flex;
  gap: 8px;
}
.mobile-btn-group button {
  flex: 1;
}
.mobile-card-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.card-item {
  background: #fff;
  border-radius: 12px;
  padding: 14px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}
.card-top {
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
}
.id-tag {
  font-size: 12px;
  color: #999;
}
.role-tag {
  font-size: 12px;
  background: #e8f3ff;
  color: #409eff;
  padding: 2px 6px;
  border-radius: 4px;
}
.card-title {
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 8px;
}
.card-time {
  font-size: 12px;
  color: #666;
  line-height: 1.5;
  margin-bottom: 10px;
}
.card-operate {
  text-align: right;
}
.mobile-pagination {
  margin-top: 15px;
  display: flex;
  justify-content: center;
}

/* ==================== 移动端弹窗专用样式 ==================== */
.mobile-dialog-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}
</style>



// WEBPACK FOOTER //
// src/pages/admin/index.vue